module.exports = __webpack_public_path__ + "img/Download_Filled_24px_Icon.716b75dc.svg";